<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-10">
        <h1>Cancelamento de consulta médica</h1>
        <hr><br>
        <span v-if="isBusy" class="text-center text-info">
            <b-spinner variant="primary" label="Aguarde..."></b-spinner>Aguarde...
        </span>
        <alert :message=message v-if="showMessage"></alert>
        <div v-if="showData">
            Paciente: <span v-html="callResult.contact"></span><br />
            Local: <span v-html="callResult.entity_name"></span><br />
            Médico: <span v-html="callResult.params.doctor"></span><br />
            Data: <span v-html="callResult.params.day"></span>/
            <span v-html="callResult.params.month"></span>/
            <span v-html="callResult.params.year"></span><br />
            Hora: <span v-html="callResult.params.hour"></span>:
            <span v-html="callResult.params.minute"></span><br />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from 'axios';
import Alert from './Alert';

export default {
  data() {
    return {
      callResult: [],
      message: '',
      showMessage: false,
      showData: false,
      ROOT_API: process.env.ROOT_API,
      isBusy: false,
    };
  },
  components: {
    alert: Alert,
  },
  methods: {
    getBooks() {
      const path = `https://api.notifier.datanuvem.ai/v1/action/cancel/${this.$route.params.token}/${this.$route.params.task}`;
      this.isBusy = true;
      axios.get(path)
        .then((res) => {
          this.callResult = res.data;
          this.message = 'Consulta cancelada com sucesso';
          this.showMessage = true;
          this.showData = true;
          this.isBusy = false;
        })
        .catch((error) => {
          if (error.response) {
            this.message = error.response.data.message;
            this.showMessage = true;
            this.showData = false;
            this.isBusy = false;
          } else if (error.request) {
            // eslint-disable-next-line
            console.error(error.request);
            this.message = error.request;
            this.showMessage = true;
            this.showData = false;
            this.isBusy = false;
          } else {
            console.error(error);
            this.message = error;
            this.showMessage = true;
            this.showData = false;
            this.isBusy = false;
          }
        });
    },
  },
  created() {
    this.getBooks();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Cancel.vue